/* Boosh chrome (v8 build, slice 3b): announcement rotation, header menu,
   bag button and count, footer country selector and FAQ link. Ported from
   the approved draft scripts (product-trimmer.html, the announcement and
   menu scripts) with Astra 6 item 4 applied: every component initialises
   on its own, guards missing elements, and survives theme editor
   shopify:section:load / unload without binding twice. */
(function () {
  if (window.BooshChrome) return;

  var components = [];
  function register(name, selector, init) { components.push({ name: name, selector: selector, init: init }); }

  function setup(scope) {
    components.forEach(function (c) {
      var els = [];
      if (scope.matches && scope.matches(c.selector)) els.push(scope);
      scope.querySelectorAll(c.selector).forEach(function (el) { els.push(el); });
      els.forEach(function (el) {
        el.__bshChrome = el.__bshChrome || {};
        if (el.__bshChrome[c.name]) return;
        var offs = [];
        el.__bshChrome[c.name] = offs;
        c.init(el, offs);
      });
    });
  }

  function teardown(scope) {
    var all = [scope];
    scope.querySelectorAll('*').forEach(function (el) { all.push(el); });
    all.forEach(function (el) {
      if (!el.__bshChrome) return;
      Object.keys(el.__bshChrome).forEach(function (k) {
        el.__bshChrome[k].forEach(function (fn) { try { fn(); } catch (e) {} });
      });
      el.__bshChrome = null;
    });
  }

  function on(offs, target, type, fn, opts) {
    if (!target) return;
    target.addEventListener(type, fn, opts);
    offs.push(function () { target.removeEventListener(type, fn, opts); });
  }

  /* Announcement bar: one message at a time, next one every 3s (the
     draft's interval). Paused while hovered or focused so the link can be
     read and reached. The fade is CSS and is off under reduced motion. */
  register('announce', '[data-bsh-announce]', function (root, offs) {
    var msgs = root.querySelectorAll('.announce__msg');
    if (msgs.length < 2) return;
    var i = 0;
    msgs.forEach(function (m, n) { if (m.classList.contains('is-on')) i = n; });
    var paused = false;
    var timer = setInterval(function () {
      if (paused || document.hidden) return;
      msgs[i].classList.remove('is-on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on');
    }, 3000);
    offs.push(function () { clearInterval(timer); });
    on(offs, root, 'mouseenter', function () { paused = true; });
    on(offs, root, 'mouseleave', function () { paused = root.contains(document.activeElement); });
    on(offs, root, 'focusin', function () { paused = true; });
    on(offs, root, 'focusout', function (e) { if (!root.contains(e.relatedTarget)) paused = root.matches(':hover'); });
  });

  /* Header menu (phones): the capsule's menu button opens the product nav
     as a panel under the header. Escape closes it and returns focus to the
     button; a tap outside, a nav link, tabbing out or widening past the
     phone breakpoint closes it too. */
  register('menu', '[data-bsh-header]', function (header, offs) {
    var btn = header.querySelector('[data-bsh-menu]');
    var nav = header.querySelector('[data-bsh-nav]');
    if (!btn || !nav) return;
    var wide = window.matchMedia ? window.matchMedia('(min-width: 900px)') : null;
    function isOpen() { return nav.classList.contains('is-open'); }
    function open() {
      nav.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      var first = nav.querySelector('a');
      if (first) first.focus();
    }
    function close(returnFocus) {
      if (!isOpen()) return;
      nav.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      if (returnFocus) btn.focus();
    }
    on(offs, btn, 'click', function () { if (isOpen()) close(false); else open(); });
    on(offs, document, 'keydown', function (e) { if (e.key === 'Escape' && isOpen()) { close(true); } });
    on(offs, nav, 'click', function (e) { if (e.target.closest('a')) close(false); });
    on(offs, document, 'click', function (e) { if (!header.contains(e.target)) close(false); });
    on(offs, header, 'focusout', function (e) { if (e.relatedTarget && !header.contains(e.relatedTarget)) close(false); });
    if (wide) {
      var onWide = function (e) { if (e.matches) close(false); };
      if (wide.addEventListener) { wide.addEventListener('change', onWide); offs.push(function () { wide.removeEventListener('change', onWide); }); }
    }
    offs.push(function () { close(false); });
  });

  /* Bag buttons: open the theme's cart drawer through its own Alpine modal
     store (as the Shapes header does). If the drawer is not ready, or the
     store runs the cart page, the link goes to /cart as normal. */
  register('bag', '[data-bsh-bag]', function (link, offs) {
    on(offs, link, 'click', function (e) {
      var theme = window.theme || {};
      if (!theme.settings || theme.settings.cartType !== 'modal') return;
      if (link.hasAttribute('data-bsh-bag-page')) return;
      var A = window.Alpine;
      var store = A && A.store ? A.store('modals') : null;
      if (!store || !store.isRegistered || !store.isRegistered('cart')) return;
      e.preventDefault();
      var header = link.closest('[data-bsh-header]');
      var nav = header ? header.querySelector('[data-bsh-nav]') : null;
      var menu = header ? header.querySelector('[data-bsh-menu]') : null;
      if (nav && nav.classList.contains('is-open')) { nav.classList.remove('is-open'); if (menu) menu.setAttribute('aria-expanded', 'false'); }
      store.open('cart');
    });
  });

  /* Bag count: the dot shows when the bag has items. It follows the same
     events the theme's cart_count store listens to (add to bag, quantity
     change, cart update), reading the cart-item-count section the theme
     already fetches with each change. */
  function countFrom(detail) {
    if (!detail) return null;
    if (typeof detail.cartItemCount === 'number') return detail.cartItemCount;
    var r = detail.response;
    if (r && r.sections && r.sections['cart-item-count']) {
      var d = document.createElement('div');
      d.innerHTML = r.sections['cart-item-count'];
      var n = parseInt(d.textContent.trim(), 10);
      if (!isNaN(n)) return n;
    }
    if (r && typeof r.item_count === 'number') return r.item_count;
    return null;
  }
  function paintCount(n) {
    if (typeof n !== 'number' || isNaN(n)) return;
    document.querySelectorAll('[data-bsh-bag]').forEach(function (b) {
      b.setAttribute('data-bag-count', String(n));
    });
  }
  function onCartEvent(e) {
    var n = countFrom(e.detail);
    if (n === null && window.theme && typeof window.theme.cartItemCount === 'number') n = window.theme.cartItemCount;
    paintCount(n);
  }

  function boot() {
    setup(document);
    ['shapes:cart:afteradditem', 'shapes:cart:cartqtychange', 'shapes:cart:update'].forEach(function (t) {
      window.addEventListener(t, onCartEvent);
    });
    document.addEventListener('theme:cart:change', onCartEvent);
    document.addEventListener('shopify:section:load', function (e) { if (e.target) setup(e.target); });
    document.addEventListener('shopify:section:unload', function (e) { if (e.target) teardown(e.target); });
  }

  /* Footer country/region: picking a country submits the theme's
     localization form, so the store switches market and currency. */
  register('country', '[data-bsh-country]', function (select, offs) {
    var form = select.form;
    if (!form) return;
    on(offs, select, 'change', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    });
  });

  /* Footer FAQ link: the draft points at the page's own #faq. On pages
     without an FAQ section it falls back to the store FAQ page. */
  register('faq', '[data-bsh-faq-link]', function (link) {
    var hash = (link.getAttribute('href') || '').trim();
    if (hash.charAt(0) !== '#') return;
    if (document.getElementById(hash.slice(1))) return;
    var fallback = (link.getAttribute('data-bsh-faq-link') || '').trim();
    if (fallback) link.setAttribute('href', fallback);
  });

  window.BooshChrome = { setup: setup, teardown: teardown };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
